export interface IOrganizationLeaf {
    id: string;
    name: string;
    children: IOrganizationLeaf[];
    disabled?: boolean;
}
